import React from 'react';
import { Modal } from 'react-bootstrap';
import styled from '@emotion/styled';

type Admin = { name: string; email: string };

interface ContactAdminModalProps {
  show: boolean;
  onHide: () => void;
  admins: Admin[];
}

const StyledModalBody = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  min-height: 500px; /* taller modal */
  padding: 2rem;
`;

const AdminListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const AdminRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0; /* vertical padding */
  border-bottom: 1px solid #ddd; /* light gray border */
  font-size: 1rem;

  &:last-of-type {
    border-bottom: none; /* remove last line */
  }

  .admin-name {
    font-weight: 600;
  }

  .admin-email a {
    color: #008995;
    text-decoration: none;

    &:hover {
      color: #f89820;
      text-decoration: underline;
    }
  }
`;

const ModalFooter = styled.footer`
  font-style: italic;
  margin-top: 1.5rem;
  color: #333;
`;

const ContactAdminModal: React.FC<ContactAdminModalProps> = ({ show, onHide, admins }) => (
  <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
    <Modal.Header
      closeButton
      style={{
        borderBottom: 'none', // clean top
      }}
    >
      <Modal.Title style={{ fontWeight: 600, fontSize: '1.25rem' }}>
        The admin(s) for your site are:
      </Modal.Title>
    </Modal.Header>

    <StyledModalBody>
      <AdminListWrapper>
        {admins && admins.length > 0 ? admins.map((a) => (
          <AdminRow key={a.email}>
            <span className="admin-name">{a.name}</span>
            <span className="admin-email">
              <a href={`mailto:${a.email}`} target="_blank" rel="noopener noreferrer">
                {a.email}
              </a>
            </span>
          </AdminRow>
        )) : (
          <p>There are no admins assigned to this burn center.</p>
        )}
      </AdminListWrapper>

      <ModalFooter>
        Your BCQP administrator manages all user modifications within BCQP, including reset of MFA
        when necessary. If your burn center currently does not have an assigned BCQP administrator
        or the current one listed is incorrect, please have your team identify who will be your
        BCQP administrator and then contact the ABA (bcqp@ameriburn.org) to update your records.
        The support team will then work with ABA to get the new burn center administrator setup in
        BCQP.
      </ModalFooter>
    </StyledModalBody>
  </Modal>
);

export default ContactAdminModal;
